export default __webpack_public_path__ + "static/media/logo-example-01.170b3399.jpg";